import { onError } from "@apollo/client/link/error";
import * as Sentry from "@sentry/react";

export const apolloErrorLink = onError(
  ({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach((error) => {
        const isClientSafeError =
          error.extensions?.code === "CLIENT_SAFE_ERROR";

        if (isClientSafeError) {
          return;
        }

        const errorInfo = {
          type: "GraphQL Error",
          message: error.message,
          path: error.path,
          extensions: error.extensions,
          operation: operation.operationName,
          variables: operation.variables,
        };

        console.error(
          `[GraphQL Error]: ${operation.operationName || "Unknown Operation"}`,
          {
            message: error.message,
            path: error.path,
            extensions: error.extensions,
            variables: operation.variables,
          },
        );

        const sentryError = new Error(
          `GraphQL Error in ${operation.operationName || "Unknown Operation"}: ${error.message}`,
        );
        sentryError.name = "GraphQLError";

        Sentry.captureException(sentryError, {
          tags: {
            errorType: "graphql",
            operation: operation.operationName || "unknown",
          },
          extra: errorInfo,
        });
      });
    }

    if (networkError) {
      const errorType =
        "statusCode" in networkError
          ? `Network Error (${networkError.statusCode})`
          : "Network Error";

      const errorInfo = {
        type: errorType,
        message: networkError.message,
        operation: operation.operationName,
        variables: operation.variables,
      };

      console.error(
        `[${errorType}]: ${operation.operationName || "Unknown Operation"}`,
        {
          message: networkError.message,
          variables: operation.variables,
        },
      );

      const sentryError = new Error(
        `${errorType} in ${operation.operationName || "Unknown Operation"}: ${networkError.message}`,
      );
      sentryError.name = errorType.replace(/[()]/g, "").replace(/\s+/g, "");

      Sentry.captureException(sentryError, {
        tags: {
          errorType: "network",
          operation: operation.operationName || "unknown",
        },
        extra: errorInfo,
      });
    }
  },
);

export function createEnhancedApolloErrorLink() {
  return apolloErrorLink;
}
